/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chats_Create_Chat_SuccessInputs */



/**
* | output |
* | --- |
* | "Chat created successfully!" |
*
* @param {Chats_Create_Chat_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chats_create_chat_success = /** @type {((inputs?: Chats_Create_Chat_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chats_Create_Chat_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Chat erfolgreich erstellt!")
	return /** @type {LocalizedString} */ ("Chat created successfully!")
});